import { useEffect, useRef } from 'react';
export default function useEffectWithCtx(cb, ctx, deps) {
    const ctxRef = useRef(ctx);
    ctxRef.current = ctx;
    useEffect(() => cb(ctxRef.current, ctxRef), deps);
}
